import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" />, 'Publish');
